import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextExtraSmall = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-4 last:mb-0 sm:mb-5 text-md">
            {children}
        </p>
    )
}

export default CopytextExtraSmall
